import Vue from 'vue'
import VueRouter from 'vue-router'
import {routerConfig} from './config.js'
import storageUtils from 'utils/js/storageUtils.js'

// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

Vue.use(VueRouter)

const router = new VueRouter({
  linkActiveClass:'is-active',
  routes:routerConfig
})

router.beforeEach((to, from, next) => {
  next();
  let routerNum=storageUtils.getRouterNum();
  if(!isNaN(Number(routerNum))){
    if(Number(routerNum)<3){
      storageUtils.saveRouterNum(Number(routerNum)+1);
    }
  }else{
    storageUtils.saveRouterNum(1);
  }
});

export default router
